import Vue from "vue";
import VueResource from "vue-resource";

Vue.use(VueResource);
Vue.http.options.root = process.env.VUE_APP_API;

Vue.http.interceptors.push((request, next) => {
  if (request.url[0] === "/") {
    // eslint-disable-next-line
    request.url = process.env.VUE_APP_API + request.url;
  }

  next((response) => {
    switch (response.status) {
      case 401:
      case 422:
        switch (response.body.message) {
          case "The token has been blacklisted":
            window.toastr.info("Login session ended");
            break;

          case "422 Unprocessable Entity":
            window.toastr.error("The given data was invalid", "Error");
            break;

          default:
            window.toastr.error(response.body.message, "Error");
            break;
        }
        break;
      case 500:
        if (response.body.message === "This action is unauthorized.") {
          window.toastr.error("This action is unauthorized", "Error");
          break;
        }

        window.toastr.error("An error occurred on API.", "Error");
        break;
      default:
    }
  });
});
